var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "popup",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.4,
    height: 15.468,
    viewBox: "0 0 15.4 15.468",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "popup",
    strokeWidth: "0.4px",
    d: "M8.827,7.5l5.9-5.9A.938.938,0,0,0,13.4.276l-5.9,5.9L1.6.276A.938.938,0,0,0,.275,1.6l5.9,5.9-5.9,5.9A.938.938,0,1,0,1.6,14.726l5.9-5.9,5.9,5.9A.938.938,0,0,0,14.725,13.4Z",
    transform: "translate(0.2 0.268)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose2);
export default __webpack_public_path__ + "static/media/close2.ca640246142a1f773fd763aadab6a5ad.svg";
export { ForwardRef as ReactComponent };